import { makeStyles } from '@material-ui/core'
// import Ymhlogo from '../../../../assets/illustrations/YMH-logo.png'
import inputonlinegiftools from '../../../../assets/illustrations/input-onlinegiftools.png'
import spanishLogoGif from '../../../../assets/illustrations/spanishLogoGiff.gif'

export default makeStyles({
  root: {
    zIndex: 90,
    boxShadow: 'none',
    backgroundColor: '#FFFFFF'
  },
  rootHeader: {
    zIndex: 90,
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%)'
  },
  space: {
    flexGrow: 1
  },
  title: {
    minWidth: '220px'
  },
  logoCls: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: '180px 40px',
    backgroundPosition: '0px 2px',
    height: '45px',
    backgroundImage: `url(${inputonlinegiftools})`
  },
  spanishlogoCls: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: '180px 40px',
    backgroundPosition: '0px 2px',
    height: '45px',
    backgroundImage: `url(${spanishLogoGif})`
  },
  titleCls: {
    width: '180px'
  },
  navStyle: {
    paddingRight: '3px',
    paddingLeft: '3px',
    fontFamily: 'Brandon Grotesque',
    fontSize: '18px',
    paddingBottom: '0'
  },
  buttonStyles: {
    color: '#0D1F48',
    fontFamily: 'Brandon Grotesque',
    fontSize: '20px',
    paddingLeft: '6px',
    paddingRight: '6px',
    '&:hover': {
      color: '#F1583A',
      textDecoration: 'none'
    }
  },
  selectedStyles: {
    color: '#F1583A',
    borderBottom: '2px solid #F1583A',
    paddingBottom: '10px',
    paddingTop: '10px',
    fontWeight: 'bold'
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    whiteSpace: 'nowrap',
    fontFamily: 'Brandon Grotesque'
  },
  chatNotificationsBadge: {
    borderRadius: '50%',
    backgroundColor: '#f1573b',
    color: '#fff',
    display: 'inline-block',
    paddingLeft: '6px',
    paddingRight: '6px',
    textAlign: 'center',
    fontSize: 'small',
    marginLeft: '5px'
  },

  buttonBox: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    fontSize: '1.25em',
    color: '#f1593a'
  },
  count: {
    position: 'absolute',
    lineHeight: 1,
    color: '#fff',
    top: '1.5em',
    fontSize: '0.5em',
    fontWeight: 800
  }
})
